var url = "";
if (window.location.host === "epixcinemas-qr-app.nuviotech.co") {
  url = "https://epixcinemas-api.nuviotech.co";
} else {
  url = "http://localhost:3800";
}
export const URL_BASE = url;



// WEBPACK FOOTER //
// ./src/helper/constants.js